import { FormRandomizeButtonModel } from '../../../../../shared/kiosk';
import { AbstractElementEditor } from './AbstractElementEditor';

export class RandomizeButtonEditor extends AbstractElementEditor<FormRandomizeButtonModel> {
  public getDescription(): string {
    return 'Randomize the badge name and species';
  }

  public getName(): string {
    return 'Randomize button';
  }

  public getIcon(): string {
    return 'shuffle';
  }
}
